import { ItemLinkProps } from '../../../Components/ItemLinks/ItemLink';
import { viewDetailsLink } from 'lib/gaTracking/bookingListPageEvents';
import { SelfServiceAPI } from 'types';

export const generateViewBookingDetailsItemLink = (booking: SelfServiceAPI.UpcomingBooking, onTrack: () => void): ItemLinkProps => ({
  label: 'View details',
  url: booking.links.manage,
  onClick: () => {
    onTrack();
    viewDetailsLink(booking);
  },
});
